jQuery(document).ready(function ($) {
  $('.carousel-main').each(function(num, elem) {
   var elems = $(elem);
    var autoplay = elems.data('carousel');
    elems.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: autoplay,
      autoplaySpeed: 7000,
      dots: false,
      // responsive: [
      //   {
      //     breakpoint: 1024,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 2,
      //     },
      //   },
      //   {
      //     breakpoint: 480,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //     },
      //   },
      // ],
    });
  });
  $(".all-reviews").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});